module.exports = __webpack_public_path__ + "static/implement_mimi_card_phone-d93ca637f5cdf97c30bffbeba73d269c.svg";